import WaitlistForm from "./WaitlistForm";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 sm:py-32 overflow-hidden fp-grain"
      style={{
        background:
          "linear-gradient(135deg, var(--fp-powder) 0%, var(--fp-rose-gold) 100%)",
      }}
    >
      {/* soft light blobs */}
      <div
        className="fp-blob"
        style={{
          width: 500,
          height: 500,
          top: -200,
          right: -200,
          background: "var(--fp-cream)",
          opacity: 0.3,
        }}
      />

      <div className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8 text-center">
        <span
          className="inline-block text-xs uppercase font-bold tracking-[0.22em] px-4 py-1.5 rounded-full"
          style={{
            background: "rgba(255, 240, 238, 0.4)",
            color: "var(--fp-espresso)",
            border: "1px solid rgba(255, 240, 238, 0.6)",
          }}
        >
          Pré-lancement
        </span>
        <h2
          className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.02]"
          style={{ color: "var(--fp-espresso)" }}
        >
          Sois parmi les <span className="italic">premier·ère·s</span>{" "}
          à essayer Floppy.
        </h2>
        <p
          className="mt-5 text-base sm:text-lg max-w-xl mx-auto"
          style={{ color: "var(--fp-ink)", lineHeight: 1.6 }}
        >
          Inscris-toi à la newsletter de lancement. On t'envoie un email le
          jour où l'app débarque sur ton téléphone. Pas un de plus, promis.
        </p>

        <div className="mt-10 max-w-lg mx-auto">
          <WaitlistForm variant="final" />
        </div>
      </div>
    </section>
  );
}
